import * as React from "react";
import moment from "moment";
import { GoCheck, GoX, GoDash } from "react-icons/go";
import SortableTbl from "react-sort-search-table";
import Modal from "react-awesome-modal";

import { StyledCard, ScoreEntry, ColorP } from "./StudentsPerformance.styles";

import { courseScoreColor, scoreRangeKeys } from "../../../common/services";

interface IProps {
  data?: any;
  selectedCourse?: string;
  selectedLesson?: string;
  isLesson?: boolean;
  isTeacher?: boolean;
  isSchool?: boolean;
}

const AttemptsTD = (props: any) => {
  const { tdData } = props;
  const className = tdData > 3 ? "red" : "yellow";

  return <td className={className}>{tdData ? tdData : 0}</td>;
};
const ScoreTD = (props: any) => {
  const { tdData } = props;
  const className = Number(tdData) < 50 ? "red" : "yellow";

  return (
    <td
      style={{
        color: courseScoreColor(Number(tdData)),
        font: "normal bold 20px 'Roboto Condensed'",
      }}
      className={className}
    >
      {tdData ? (
        `${Number(tdData).toFixed()}%`
      ) : (
        <GoDash size="32px" color="#ff0033" />
      )}
    </td>
  );
};

const AnswerTD = (props: any) => {
  const { tdData } = props;

  if (tdData === null) {
    return (
      <td>
        <GoDash size="32px" color="#ff0033" />
      </td>
    );
  }

  return (
    <td>
      {tdData ? (
        <GoCheck size="32px" color="#b5f92d" />
      ) : (
        <i
          className="fa fa-circle"
          style={{ fontSize: "28px", color: "#ff7a03" }}
        />
      )}
    </td>
  );
};

class StudentsPerformance extends React.Component<IProps> {
  public state = {
    showScoreModal: false,
    modalData: null as any,
    averageScoreData: { score: 0, range: "range_1", color: "#ff0033" } as any,
    showAvgScoreModal: false,
  };

  constructor(props) {
    super(props);
  }

  public closeModalWithData = (data) => {
    this.setState({ showScoreModal: false });
  };

  public TeacherAnswerTD = (props: any) => {
    console.log({props});

    const { tdData } = props;

    if (tdData === null || typeof tdData === 'undefined') {
      return (
        <td>
          <GoDash size="32px" color="#ff0033" />
        </td>
      );
    }else {
      // must be defined here to avoid an undefined final_score
      const { final_score } = tdData;
      return (
        <td>
          {final_score > 0 ? (
            <GoCheck size="32px" color="#b5f92d" />
          ) : (
            <i
              className="fa fa-circle"
              style={{ fontSize: "28px", color: "#ff7a03" }}
            />
          )}
          <i
            style={{
              fontSize: "28px",
              color: "#ff0033",
              float: "right",
              cursor: "pointer",
            }}
            className="fa fa-question-circle"
            // tslint:disable-next-line jsx-no-lambda
            onClick={() => {
              this.setState({ modalData: { ...tdData }, showScoreModal: true });
            }}
          />
        </td>
      );
    }

   

  };

  public AverageScoreTd = (props: any) => {
    const { tdData } = props;
    const rangeKey = scoreRangeKeys(tdData);
    const rangeColor = courseScoreColor(tdData);

    return (
      <td>
        <span style={{ color: courseScoreColor(tdData) }}>{tdData}%</span>
        <i
          style={{
            fontSize: "28px",
            color: "#ff0033",
            float: "right",
            cursor: "pointer",
          }}
          className="fa fa-question-circle"
          // tslint:disable-next-line jsx-no-lambda
          onClick={() => {
            this.setState({
              averageScoreData: {
                score: tdData,
                range: rangeKey,
                color: rangeColor,
              },
              showAvgScoreModal: true,
            });
          }}
        />
      </td>
    );
  };

  public renderScoreDataModal = () => {
    const { modalData } = this.state;

    return modalData != null ? (
      <Modal
        visible={this.state.showScoreModal}
        effect="fadeInDown"
        // height="500"
        width="500"
      >
        <div
          style={{
            height: "100%",
            backgroundColor: "#1a1a1a",
            padding: "20px",
          }}
        >
          <div style={{ marginBottom: "30px" }} className="action-wrapper">
            <i
              style={{
                fontSize: "28px",
                color: "#ff0033",
                float: "right",
                cursor: "pointer",
              }}
              className="fa fa-times red"
              onClick={this.closeModalWithData}
            />
          </div>
          <ScoreEntry>
            <h2 className="modal-data-header">
              Final Score: {Math.round(modalData.final_score)}
            </h2>
            <p>
              This is your learner’s final score across their entire performance
              in the pathway. The higher the number, the better they did, so
              reward and praise them accordingly.
            </p>
          </ScoreEntry>
          <ScoreEntry>
            <h2 className="modal-data-header">
              Frequency: {modalData.frequency}
            </h2>
            <p>
              This outlines how many attempts your learners took when completing
              the interactive quiz allocated to them in this pathway. Ideally,
              we want to keep this below 3 attempts.
            </p>
          </ScoreEntry>

          <ScoreEntry>
            <h2 className="modal-data-header">
              Frequency Penalty: {modalData.frequency_penalty}
            </h2>
            <p>
              This outlines the penalty given to the learner for taking too many
              attempts (frequency) to complete the interactive quiz. Only you
              will see this as we do not want the learner to lose motivation.
            </p>
          </ScoreEntry>
          <ScoreEntry>
            <h2 className="modal-data-header">
              Time Taken: {modalData.time_taken} seconds
            </h2>
            <p>
              This outlines the total time for the learner to complete the
              interactive quiz in their pathway. Ideally, the less time taken,
              the lower the time penalty and frequency, and the better they will
              get.
            </p>
          </ScoreEntry>
          <ScoreEntry>
            <h2 className="modal-data-header">
              Time Penalty: {modalData.time_penalty}
            </h2>
            <p>
              This outlines the time penalty given to the learner for taking too
              long (timing) to complete the interactive quiz. Only you will see
              this as we do not want the learner to lose motivation.
            </p>
          </ScoreEntry>
        </div>
      </Modal>
    ) : (
      ""
    );
  };

  public renderAverageScoreModal = () => {
    const {
      averageScoreData,
      averageScoreData: { range, score, color },
    } = this.state;

    let content: React.ReactElement = <></>;

    if (averageScoreData === null) {
      content = <></>;
    } else {
      if (range === "range_1") {
        content = (
          <ScoreEntry>
            <h2
              style={{ color: courseScoreColor(score) }}
              className="modal-data-header"
            >
              0-5% Needs a major boost
            </h2>
            <ColorP color={color}>
              Performance is in the low %, your learner needs a boost in skills
              in this area.
            </ColorP>
            <ColorP color={color}>
              <span>
                Make sure the Challenge work for this Skill is in progress
              </span>
              - this will help them put this new Skill to use and start to imbed
              it in their learning.
            </ColorP>
            <ColorP color={color}>
              Arrange a regular check-in with them about how they’re finding
              their Challenge work and support them to structure a plan for how
              to kick off using their new Skill.
            </ColorP>

            <h3 style={{ color }}>Top tip: </h3>
            <ColorP color={color}>
              Start by <span>using the Skill with just one topic</span> - this
              may help them not to feel overwhelmed.
            </ColorP>
            <p>
              You may want to recommend they focus on a topic they’re confident
              in before applying the Skill to topics they are less confident in.
            </p>
          </ScoreEntry>
        );
      }

      if (range === "range_2") {
        content = (
          <ScoreEntry>
            <h2
              style={{ color: courseScoreColor(score) }}
              className="modal-data-header"
            >
              6-25% Good start, long way to go
            </h2>
            <p>
              Your learner has shown effort but they have a way to go to imbed
              the new Skill.
            </p>
            <ColorP color={color}>
              Check in with them frequently and{" "}
              <span>reinforce the importance of their Challenge work.</span>
            </ColorP>
            <p>
              Completing the Challenges will help make the new Skill part of
              their routine.
            </p>

            <h3 style={{ color }}>Top tip: </h3>
            <ColorP color={color}>
              You may find that encouragement is needed to maintain{" "}
              <span>positivity and praise towards them.</span>
            </ColorP>
            <p>
              Don’t forget - all lessons can be repeated if a recap is needed.
            </p>
          </ScoreEntry>
        );
      }

      if (range === "range_3") {
        content = (
          <ScoreEntry>
            <h2
              style={{ color: courseScoreColor(score) }}
              className="modal-data-header"
            >
              26-50% Good effort, room to improve
            </h2>
            <p>
              Performance between 26 - 50% shows good effort but there is room
              to improve.
            </p>
            <ColorP color={color}>
              Your learner should{" "}
              <span>
                keep using their new Skill across all of their learning
              </span>{" "}
              and go back to review the lesson after they’ve completed their
              Challenges.
            </ColorP>
            <p>Check in with them about how they feel about their progress</p>

            <h3 style={{ color }}>Top tip: </h3>
            <ColorP color={color}>
              Ask them to{" "}
              <span>practice the Skill with a subject they’re doing ok in</span>{" "}
              before tackling subjects they may be struggling in.
            </ColorP>
            <ColorP color={color}>
              This will help <span>build confidence</span> and embed the Skill
              ready for use across all subjects.
            </ColorP>
            <p>Keep praising them, they have huge potential.</p>
          </ScoreEntry>
        );
      }

      if (range === "range_4") {
        content = (
          <ScoreEntry>
            <h2
              style={{ color: courseScoreColor(score) }}
              className="modal-data-header"
            >
              51-75% Good work, keep up the momentum
            </h2>
            <p>
              Great score, 51 - 75% puts your learner nearly in the top-scoring
              band! <br /> In most cases, they’ll have grasped the new Skill
              well and be implementing it in most but maybe not all areas of
              their learning.
            </p>
            <ColorP color={color}>
              <span> Review their Challenge work with</span> them and see how
              they’re progressing and help them keep up their momentum.
            </ColorP>

            <h3 style={{ color }}>Top tip: </h3>
            <ColorP color={color}>
              Encourage them to{" "}
              <span>use the new Skill across ALL of their subjects.</span>
            </ColorP>

            <p>
              This may move them out of their comfort zone but they have shown
              they have the ability.
            </p>
          </ScoreEntry>
        );
      }

      if (range === "range_5") {
        content = (
          <ScoreEntry>
            <h2
              style={{ color: courseScoreColor(score) }}
              className="modal-data-header"
            >
              76-100% Outstanding performance, keep it up
            </h2>
            <p>
              Your learner is smashing it! They’ve engaged with the new Skill
              and will be starting to use it in their day-to-day learning.
            </p>

            <h3 style={{ color }}>Top tip: </h3>
            <p>
              If they aren’t already doing this, they can easily stretch
              themselves and use the new Skill across all of their learning
              every day.
            </p>
            <ColorP color={color}>
              Overall, this is{" "}
              <span>
                great score band to be in and they should be exceedingly proud
                of their progress.
              </span>
            </ColorP>
          </ScoreEntry>
        );
      }
    }

    return averageScoreData != null ? (
      <Modal
        visible={this.state.showAvgScoreModal}
        effect="fadeInDown"
        // height="500"
        width="500"
      >
        <div
          style={{
            height: "100%",
            backgroundColor: "#1a1a1a",
            padding: "28px",
          }}
        >
          <div style={{ marginBottom: "30px" }} className="action-wrapper">
            <i
              style={{
                fontSize: "28px",
                color: "#ff0033",
                float: "right",
                cursor: "pointer",
              }}
              className="fa fa-times red"
              // tslint:disable-next-line jsx-no-lambda
              onClick={() => {
                this.setState({ showAvgScoreModal: false });
              }}
            />
          </div>

          {content}
        </div>
      </Modal>
    ) : (
      ""
    );
  };

  public renderCoursePerformance() {
    const tHead = new Array();
    const tableData = new Array();
    const { data, selectedCourse } = this.props;
    const course = data.CoursesAvailable[Number(selectedCourse)];
    const students = course.StudentsEnrolled;

    students.forEach((student: any) => {
      const rowData: any = { Student: student.Name };
      student.LessonAllocations.forEach((lesson: any) => {
        rowData[lesson.LessonIdentifier] = lesson.BestScore;

        if (!tHead.includes(lesson.LessonIdentifier)) {
          tHead.push(lesson.LessonIdentifier);
        }
      });

      tableData.push(rowData);
    });

    tHead.unshift("Learner");

    const dKey = [...tHead];
    const customTd = dKey
      .slice(1)
      .map((td) => ({ custd: ScoreTD, keyItem: td }));

    if (!selectedCourse || tableData.length === 0) {
      return null;
    }

    return (
      <StyledCard
        scrollable={true}
        title={
          <div>
            Your Learners' Performance in
            <span> {course.Name}</span>
          </div>
        }
      >
        <SortableTbl
          dKey={dKey}
          tHead={tHead}
          defaultCSS={false}
          tblData={tableData}
          search={false}
          paging={false}
          customTd={customTd}
        />
      </StyledCard>
    );
  }

  public renderLessonPerformance() {
    const dKey = new Array();
    const tHead = new Array();
    const tableData = new Array();
    const { data, selectedLesson } = this.props;
    const lesson = data.Lessons[Number(selectedLesson)];
    const students = lesson.Students;

    students.forEach((student: any) => {
      const rowData: any = {
        Student: student.Name,
        Attempts: student.Attempts,
        "Last Score": student.LastScore,
      };

      student.Performance.forEach((question: any) => {
        rowData[`Q${question.question_number}`] = question.correct;

        if (!tHead.includes(`Q${question.question_number}\n${question.type}`)) {
          dKey.push(`Q${question.question_number}`);
          tHead.push(`Q${question.question_number}\n${question.type}`);
        }
      });

      tableData.push(rowData);
    });

    tHead.unshift("Last Score");
    tHead.unshift("Attempts");
    tHead.unshift("Learner");
    dKey.unshift("Last Score");
    dKey.unshift("Attempts");
    dKey.unshift("Student");

    const customTd1 = dKey
      .slice(1, 2)
      .map((td) => ({ custd: AttemptsTD, keyItem: td }));
    const customTd2 = dKey
      .slice(2, 3)
      .map((td) => ({ custd: ScoreTD, keyItem: td }));
    const customTd3 = dKey
      .slice(3)
      .map((td) => ({ custd: AnswerTD, keyItem: td }));

    const customTd = [...customTd1, ...customTd2, ...customTd3];

    if (!selectedLesson || tableData.length === 0) {
      return null;
    }

    return (
      <StyledCard
        scrollable={true}
        title={`${lesson.LessonIdentifier} Analysis`}
        className="table-th-centered"
      >
        <SortableTbl
          dKey={dKey}
          tHead={tHead}
          defaultCSS={false}
          tblData={tableData}
          search={false}
          paging={false}
          customTd={customTd}
        />
      </StyledCard>
    );
  }

  public renderTeacherLessonPerformance() {
    const dKey = new Array();
    const tHead = new Array();
    const tableData = new Array();
    const { data, selectedLesson } = this.props;
    // const lesson = data.Lessons[Number(selectedLesson)];
    console.log({'PERFORMANCE': data})
    const students = data.lesson_learners;

    students.forEach((student: any) => {
      const rowData: any = {
        Student: `${student.name}`,
        // Attempts: student.Attempts,
        "Average Score": Math.round(student.avg_score),
      };

      student.performance.forEach((question: any, index: number) => {
        rowData[`Q${index}`] = question.scoredata;

        if (!tHead.includes(`Q${index + 1}\nLearning Quiz`)) {
          dKey.push(`Q${index}`);
          tHead.push(`Q${index + 1}\nLearning Quiz`);
        }
      });

      tableData.push(rowData);
    });

    tHead.unshift("Average Score");

    tHead.unshift("Learner");
    dKey.unshift("Average Score");
    dKey.unshift("Student");

    const customTd1 = tHead
      .slice(1)
      .map((th) => ({ custd: this.AverageScoreTd, keyItem: th }));

    const customTd2 = dKey
      .slice(1, 2)
      .map((td) => ({ custd: ScoreTD, keyItem: td }));
    const customTd3 = dKey
      .slice(2)
      .map((td) => ({ custd: this.TeacherAnswerTD, keyItem: td }));

    const customTd = [...customTd2, ...customTd3, ...customTd1];

    if (!selectedLesson || tableData.length === 0) {
      return null;
    }

    return (
      <StyledCard
        scrollable={true}
        title={`Lesson Analysis`}
        className="table-th-centered"
      >
        {this.renderScoreDataModal()}
        {this.renderAverageScoreModal()}

        <SortableTbl
          dKey={dKey}
          tHead={tHead}
          defaultCSS={false}
          tblData={tableData}
          search={false}
          paging={false}
          customTd={customTd}
        />
      </StyledCard>
    );
  }

  public render() {
    const { isLesson, isTeacher, isSchool } = this.props;
    if ((isTeacher || isSchool) && isLesson) {
      return this.renderTeacherLessonPerformance();
    }

    if (isLesson && !isTeacher) {
      return this.renderLessonPerformance();
    }

    return this.renderCoursePerformance();
  }
}

export default StudentsPerformance;



// WEBPACK FOOTER //
// ./src/components/DataCentre/StudentsPerformance/StudentsPerformance.tsx